export const tabsNav = {
    subscriptions: {
        id: 'subscriptions',
        name: 'Подписки',
        template: 'subscriptions',
        pathName: 'subscriptions',
        icon: 'briefcase',
        iconSize: '15',
    },  
    subscriptionTypes: {
        id: 'subscriptionTypes',
        name: 'Типы подписок',
        template: 'subscriptionTypes',
        pathName: 'subscriptionTypes',
        icon: 'briefcase',
        iconSize: '15',
    },
};
